import { render, staticRenderFns } from "./Overflow.vue?vue&type=template&id=208159de&scoped=true&"
import script from "./Overflow.vue?vue&type=script&lang=ts&"
export * from "./Overflow.vue?vue&type=script&lang=ts&"
import style0 from "./Overflow.vue?vue&type=style&index=0&id=208159de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208159de",
  null
  
)

export default component.exports